import { JobLocationContext } from '@factoryfixinc/ats-interfaces';

/** Answer to "Where is the work performed?" */
export type WorkPerformed = 'worksite' | 'field';
/** Answer to "Where must the worker live?" (field branch only) */
export type WorkerLives = 'near' | 'anywhere';

type Context = JobLocationContext | null | undefined;

// A null context reads as fixed_location everywhere (legacy rows and flag-off writers).
export function workPerformedFor(context: Context): WorkPerformed {
  return isFieldContext(context) ? 'field' : 'worksite';
}

export function workerLivesFor(context: Context): WorkerLives | null {
  if (context === JobLocationContext.LIVES_NEAR) return 'near';
  if (context === JobLocationContext.NATIONWIDE) return 'anywhere';
  return null;
}

export function locationContextFor(
  workPerformed: WorkPerformed,
  workerLives: WorkerLives | null,
): JobLocationContext | null {
  if (workPerformed === 'worksite') return JobLocationContext.FIXED_LOCATION;
  if (workerLives === 'near') return JobLocationContext.LIVES_NEAR;
  if (workerLives === 'anywhere') return JobLocationContext.NATIONWIDE;
  return null;
}

export function isFieldContext(context: Context): boolean {
  return context === JobLocationContext.LIVES_NEAR || context === JobLocationContext.NATIONWIDE;
}

/**
 * The `project.location` string saved next to the job ("City, ST, USA" today). The typed
 * address is kept in the form across branch switches, but persistence nulls city/state on a
 * nationwide job row, so the project string has to follow the context, not the raw fields.
 */
export function projectLocationFor(
  context: Context,
  city: string | null | undefined,
  state: string | null | undefined,
): string {
  if (context === JobLocationContext.NATIONWIDE) return 'USA';
  return `${city ? `${city}, ` : ''}${state ? `${state}, ` : ''}USA`;
}
